import {useEffect, useState } from 'react';
import RangeSlider from '@src/components/common/rangeSlider/RangeSlider';
import { numberToKorean } from '@src/utils';
import './selectRangeSlider.scss';
import { TFilterTag } from '@src/types/weddingHallFilter';


interface ISelectPriceRangeSlider {
	type: 'RENTAL_PRICE' | 'MEAL_PRICE';
	onRangeChange: (min: number, max: number) => void;
	tags: TFilterTag[];
}
const SelectPriceRangeSlider = ({ type, onRangeChange, tags }: ISelectPriceRangeSlider) => {
  const initalValues = type === 'RENTAL_PRICE' ? [0, 15000000] : [40000, 200000];
  const tag = type === 'RENTAL_PRICE' ? tags.filter(tag => (tag.typeName === 'RENTAL_PRICE')) : tags.filter(tag => (tag.typeName === 'MEAL_PRICE'))
  const values = tag[0]?.value as number[] || initalValues;

  const [rentalFeerangeValues, setRentalFeeRangeValues] = useState<number[]>(values);
  const [mealFeerangeValues, setMealFeeRangeValues] = useState<number[]>(values);


  const handleRangeChange = (data: number[]) => {
    if(type === 'RENTAL_PRICE'){
      setRentalFeeRangeValues([data[0], data[1]])
    }else {
      setMealFeeRangeValues([data[0], data[1]])
    }
  };


  const handleThumbDragEnd = () =>{

    if(type === 'RENTAL_PRICE'){
      const [min,max] = rentalFeerangeValues;
      onRangeChange(min, max);
    }else {
      const [min,max] = mealFeerangeValues;
      onRangeChange(min, max);
    }
  }

  return (
    <div className='slider-wrap'>
      {type === 'RENTAL_PRICE' && 
      <>
        <p className='range-title-bold bold'>
        {`${numberToKorean(rentalFeerangeValues[0]) || '0원'} ~ ${numberToKorean(rentalFeerangeValues[1]) || '0원'}`}
      </p>
      <div className='range-slider-wrap-flex'>
        <p>0원</p>
        <RangeSlider 
          className='dual-range-slider'
          min={0} 
          max={30000000} 
          step={1000000}
          value={rentalFeerangeValues}
          onInput={handleRangeChange}
          onThumbDragEnd={handleThumbDragEnd}
        />
        <p>1억 이상</p>
      </div>
      </>}

      {type === 'MEAL_PRICE' && 
      <>
        <p className='range-title-bold bold'>
        {`${numberToKorean(mealFeerangeValues[0]) || '4만원' } ~ ${numberToKorean(mealFeerangeValues[1]) || '0원'}`}
      </p>
      <div className='range-slider-wrap-flex'>
        <p>4만원</p>
        <RangeSlider 
          className='dual-range-slider'
          min={40000} 
          max={200000} 
          step={10000}
          value={mealFeerangeValues}
          onInput={handleRangeChange}
          onThumbDragEnd={handleThumbDragEnd}
        />
        <p>20만원</p>
      </div>
      </>}
    
    </div>
  );
};

export default SelectPriceRangeSlider;